module.exports = __webpack_public_path__ + "img/r1.5e0aa69c.jpg";